import { create } from "zustand";

type PageModalStore = {
  isOpen: boolean;
  data: { id: string } | null;
  openModal: (data: { id: string }) => void;
  closeModal: () => void;
};

export const usePageModalStore = create<PageModalStore>((set) => ({
  isOpen: false,
  data: null,
  openModal: (data) => set({ isOpen: true, data }),
  closeModal: () => set({ isOpen: false, data: null }),
}));
